import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function UseCaseDMCPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-767">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-768">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-769">
          <div className="aurora-blob bg-[#00E5FF] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-770"></div>
          <div className="aurora-blob bg-[#7B2FFF] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-771"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-772">
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-773">
            <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-774">
              {t('useCaseDMC.badge')}
            </span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-775">
            {t('useCaseDMC.heroTitle')}
            <span className="text-gradient" data-id="element-776">
              {t('useCaseDMC.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-777">
            {t('useCaseDMC.heroDesc')}
          </p>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(0,229,255,0.3)]" data-id="element-778">
            {t('useCaseDMC.bookDemo')}
          </a>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-779">
        <div className="max-w-4xl mx-auto px-6" data-id="element-780">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-781">
            {t('useCaseDMC.challengeTitle')}
          </h2>
          <div className="space-y-6" data-id="element-782">
            {[0, 1, 2].map(idx => <div key={idx} className="flex items-center p-8 bg-[#050505] rounded-2xl border border-white/10" data-id="element-783">
                <div className="w-1.5 h-12 rounded-full bg-white/20 mr-6 shrink-0" data-id="element-784"></div>
                <p className="text-xl text-white/80 font-medium" data-id="element-785">
                  {t(`useCaseDMC.pain${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-786">
        <div className="max-w-7xl mx-auto px-6" data-id="element-787">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-788">
            {t('useCaseDMC.solutionTitle')}
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-789">
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10" data-id="element-790">
              <h3 className="text-2xl font-bold mb-8 text-gradient" data-id="element-791">
                {t('useCaseDMC.travelerAppTitle')}
              </h3>
              <ul className="space-y-6" data-id="element-792">
                {[0, 1, 2, 3].map(idx => <li key={idx} className="flex items-start" data-id="element-793">
                    <div className="w-2 h-2 rounded-full bg-gradient-animated mr-4 mt-2 shrink-0" data-id="element-794"></div>
                    <span className="text-lg text-white/80" data-id="element-795">
                      {t(`useCaseDMC.travelerFeature${idx}`)}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10" data-id="element-796">
              <h3 className="text-2xl font-bold mb-8 text-gradient" data-id="element-797">
                {t('useCaseDMC.adminDashboardTitle')}
              </h3>
              <ul className="space-y-6" data-id="element-798">
                {[0, 1, 2, 3].map(idx => <li key={idx} className="flex items-start" data-id="element-799">
                    <div className="w-2 h-2 rounded-full bg-gradient-animated mr-4 mt-2 shrink-0" data-id="element-800"></div>
                    <span className="text-lg text-white/80" data-id="element-801">
                      {t(`useCaseDMC.adminFeature${idx}`)}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
          <div className="text-center" data-id="element-802">
            <p className="text-xl text-white/80 max-w-3xl mx-auto italic" data-id="element-803">
              {t('useCaseDMC.whiteLabelNote')}
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-804">
        <div className="max-w-5xl mx-auto px-6" data-id="element-805">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-806">
            {t('useCaseDMC.edgeTitle')}
          </h2>
          <div className="space-y-8" data-id="element-807">
            {[0, 1].map(idx => <div key={idx} className="flex items-stretch p-8 bg-[#050505] rounded-2xl border border-white/5" data-id="element-808">
                <div className="w-1.5 rounded-full bg-gradient-animated mr-8 shrink-0" data-id="element-809"></div>
                <p className="text-xl text-white/80 leading-relaxed italic" data-id="element-810">
                  "{t(`useCaseDMC.scenario${idx}`)}"
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-811">
        <div className="max-w-7xl mx-auto px-6" data-id="element-812">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-813">
            {t('useCaseDMC.deploymentTitle')}
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-814">
            <div className="group relative rounded-3xl overflow-hidden bg-[#0A0A0A] min-h-[300px]" data-id="element-815">
              <div className="absolute inset-0 border border-white/10 rounded-3xl group-hover:opacity-0 transition-opacity duration-300" data-id="element-816"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-gradient-animated rounded-3xl" data-id="element-817"></div>
              <div className="relative h-full p-10 flex flex-col justify-end z-10" data-id="element-818">
                <h3 className="text-3xl font-bold mb-4 text-white" data-id="element-819">
                  {t('useCaseDMC.deployment0Title')}
                </h3>
                <p className="text-white/60 text-lg leading-relaxed mb-8" data-id="element-820">
                  {t('useCaseDMC.deployment0Desc')}
                </p>
                <button type="button" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300" data-id="element-821">
                  {t('useCaseDMC.learnMore')}{' '}
                  <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-822" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-823">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-824">
          <h2 className="text-3xl md:text-5xl font-bold mb-16" data-id="element-825">
            {t('useCaseDMC.pricingTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-826">
            <div className="bg-[#050505] border border-white/10 rounded-2xl p-8 border-gradient-animated" data-id="element-827">
              <div className="relative z-10" data-id="element-828">
                <h3 className="text-xl font-medium text-white mb-2" data-id="element-829">
                  {t('useCaseDMC.platformLicense')}
                </h3>
                <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-830">
                  <p className="text-3xl font-bold text-gradient" data-id="element-831">€4,800</p>
                  <span className="text-lg text-white/40 font-normal" data-id="element-832">
                    {t('pricing.year')}
                  </span>
                  <span className="text-white/40 mx-2" data-id="element-833">+</span>
                  <p className="text-3xl font-bold text-gradient" data-id="element-834">€500</p>
                  <span className="text-lg text-white/40 font-normal" data-id="element-835">
                    {t('pricing.op')}
                  </span>
                </div>
                <p className="text-sm text-white/60 leading-relaxed" data-id="element-836">
                  {t('pricing.platformLicenseDesc')}
                </p>
              </div>
            </div>
            <div className="bg-[#050505] border border-white/10 rounded-2xl p-8" data-id="element-837">
              <div className="flex justify-between items-start mb-2" data-id="element-838">
                <h3 className="text-xl font-medium text-white" data-id="element-839">
                  {t('pricing.singleOperation')}
                </h3>
                <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-white/60" data-id="element-840">
                  {t('pricing.noCommitment')}
                </span>
              </div>
              <p className="text-3xl font-bold text-white mb-4" data-id="element-841">
                €3,000{' '}
                <span className="text-lg text-white/40 font-normal" data-id="element-842">
                  {t('pricing.oneTimeLabel')}
                </span>
              </p>
              <p className="text-sm text-white/60 leading-relaxed" data-id="element-843">
                {t('pricing.singleOperationDesc')}
              </p>
            </div>
          </div>
          <Link to="/pricing" className="inline-flex items-center text-lg font-semibold text-gradient hover:tracking-wide transition-all duration-300" data-id="element-844">
            {t('useCaseDMC.seeFullPricing')}{' '}
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-845" />
          </Link>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-846">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-847">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-848"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-849"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-850">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-851">
            {t('useCaseDMC.ctaTitle')}
            <span className="text-gradient" data-id="element-852">
              {t('useCaseDMC.ctaHighlight')}
            </span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-853">
            {t('useCaseDMC.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}